import { ProductListAdList, ProductListAdCreate, ProductListAdEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        ProductListAdList,
        ProductListAdCreate,
        ProductListAdEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'productListAd',
    icon: 'fa-sign',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/ProductListAd/index.ts